import React from "react";
import Main from "../pages/Main";
import AppBreadcrumbs from "./ui/AppBreadcrumbs";
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { autoDateFormat } from "../utils/autoDateFormate";

import BrandLogo from "../utils/logoImg";
import { useBranding } from "../context/BrandingContext";
const WelcomeLetter = () => {
  const { userInfo } = useSelector((state) => state?.auth);
const navigate = useNavigate();
  const { settings, mediaUrl, companyName, formatDate } = useBranding();

  const certLogo = settings?.certificateLogoUrl
    ? mediaUrl(settings.certificateLogoUrl)
    : null;
  const signatureImg = settings?.certificateSignatureUrl
    ? mediaUrl(settings.certificateSignatureUrl)
    : null;
  const stampImg = settings?.certificateStampUrl
    ? mediaUrl(settings.certificateStampUrl)
    : null;
  return (
    <Main showRightPanel={false} showInfoText={false}>
      <div className="mt-4 font-[Poppins]">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "Agent Profile" },
            { label: "Welcome Letter" },
          ]}
        />
       <div className=" shadow-sm border border-gray-200 rounded-lg p-2 mb-4 mt-4 flex items-center justify-between">
  {}
  <div className="flex items-center gap-2">
    <img
      src={`${userInfo?.logo}`}
      alt="profile"
      className="h-10 w-10 object-cover rounded-md"
    />
    <div className="flex flex-col md:flex-row md:items-center md:gap-2 whitespace-nowrap">
      <p className="text-[13px] md:text-[15px] font-semibold">
        {userInfo?.name || "Guest"} 
      </p>
      <p className="hidden md:block text-[18px] font-semibold">|</p>
      <p className="text-[11px] md:text-[15px] font-semibold md:mt-0 mt-[2px]">
        ID: {userInfo?.userName || "N/A"}
      </p>
    </div>
  </div>
  <div className="flex items-center gap-3">
    <button
      onClick={() => navigate(-1)}
      className="bg-primary-soft make-text-primary px-4 py-2 rounded-md text-xs font-semibold 
      hover:opacity-90 transition whitespace-nowrap flex items-center gap-2"
    >
      <PersonRoundedIcon fontSize="small" />
      <span className="hidden md:inline">Back To Profile</span>
    </button>
 <button
  onClick={() => window.print()}
  className="
    bg-primary-soft make-text-primary px-4 py-2 rounded-md text-xs font-semibold 
    hover:opacity-90 transition whitespace-nowrap flex items-center gap-2
  "
>
  <PrintRoundedIcon fontSize="small" />
  <span className="hidden md:inline">Print</span>
</button>

  </div>
</div>
<div className="print-area  mt-4 p-0 md:p-6  md:shadow-sm md:border md:border-gray-300 md:rounded-lg">
  <div className="flex justify-center">
     {/* <h1 className="text-[32px] font-bold">
        <span className="text-[#01acf1]">Ezy</span>
        <span className="text-[#e63946]">Pay</span>
      </h1> */}
         <BrandLogo variant="blue" size="lg" />
  </div>
  <h2 className="text-center text-lg font-semibold  underline mb-6">Welcome Letter</h2>
  <div className="text-[15px] leading-7  space-y-6">
    {/* <p>
      <span className="font-semibold">Dear Clients/Participants & Families,</span>
      <br /><br />
      We would like to welcome you as a New Associate to JSS MANAGEMENT AND SUPPLY. */}
      <p>
  <span className="font-semibold">Dear Clients/Participants & Families,</span>
  <br /><br />
  We would like to welcome you as a New Associate to {companyName ?? "EzyPayInd"}.
      It is our pleasure to be able to work with you or your family member.
      In this sector, we are the fastest growing organization provider with the best of our services.
    </p>
    <p>
      This is the personal thanks to you for being a part of our system.
      We hope the service which we are prepared to render will be so satisfactory that
      we shall often have the privilege of meeting your requirements, thus allowing us
      to add your name to our long and growing list of friends.
    </p>
    <p>
      You will find, we are sure, the quality of package and the advantages of the system
      exactly as presented by our representative. We do hope that our services will
      lead us more and more opportunities to serve you the best of our side,
      in the near future.
    </p>
    <p className="font-semibold mt-6">
     Please find the below mentioned details of your enrollment with {companyName ?? "EzyPayInd"} as:
    </p>
    <table className="w-full border border-black text-[14px]">
      <tbody>
        <tr className="border border-black">
          <td className="border border-black p-2 font-semibold w-[25%]">CSP Code</td>
          <td className="border border-black p-2 w-[25%]">{userInfo?.userName || "Guest"}</td>
          <td className="border border-black p-2 font-semibold w-[25%]">Associate Name</td>
          <td className="border border-black p-2 w-[25%]">{userInfo?.name}</td>
        </tr>
        <tr className="border border-black">
          <td className="border border-black p-2 font-semibold">CSP Name</td>
         
          <td className="border border-black p-2">
  {companyName || "JSS MANAGEMENT AND SUPPLY"}
</td>
          <td className="border border-black p-2 font-semibold">CSP Email</td>
          <td className="border border-black p-2">{userInfo?.email}</td>
        </tr>
        <tr className="border border-black">
          <td className="border border-black p-2 font-semibold">Mobile Number</td>
          <td className="border border-black p-2">{userInfo?.phone || "-"}</td>
          <td className="border border-black p-2 font-semibold">Aadhar Number</td>
          <td className="border border-black p-2">{userInfo?.isKyc && userInfo?.kycId?.aadhaar ? userInfo?.kycId?.aadhaar :"__"}</td>
        </tr>
        <tr className="border border-black">
          <td className="border border-black p-2 font-semibold">CSP Type</td>
          <td className="border border-black p-2 uppercase">{userInfo?.role}</td>
          <td className="border border-black p-2 font-semibold">Joining Date</td>
          <td className="border border-black p-2">{autoDateFormat(userInfo?.createdAt)}</td>
        </tr>
        <tr className="border border-black">
          <td className="border border-black p-2 font-semibold">CSP Address</td>
          <td colSpan={3} className="border border-black p-2">
            {userInfo?.kycId?.address || "-"}
          </td>
        </tr>
      </tbody>
    </table>
    {/* <div className="mt-10">
      <p className="">Very truly yours,</p>
      <p className="font-semibold">EzyPayInd</p>
    </div> */}
    <div className="mt-10 flex justify-between items-end gap-6">
  <div>
    <p className="">Very truly yours,</p>
    <p className="font-semibold">{companyName || "EzypayInd"}</p>
  </div>

  <div className="flex flex-col items-center min-w-[180px] text-center">
    {stampImg ? (
      <img
        src={stampImg}
        alt="Stamp"
        className="h-14 w-auto object-contain mb-1 opacity-90"
      />
    ) : null}

    {signatureImg ? (
      <img
        src={signatureImg}
        alt="Authorized Signature"
        className="h-10 w-auto object-contain mb-1"
      />
    ) : (
      <p className="font-semibold italic">
        {settings?.authorizedSignatoryName || "Authorized Signatory"}
      </p>
    )}

    <p className="text-xs mt-1 font-medium">
      Authorized Signature
    </p>
  </div>
</div>
  </div>
</div>
      </div>
    </Main>
  );
};
export default WelcomeLetter;
